import * as z from "zod";
import { mutator } from "./mutator";

export const dismissConnectionClaim = mutator({
  schema: z.object({ claimId: z.string() }),
  resolve: {
    claim: { kind: "connectionClaim", from: "claimId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.claim.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { claim } }) => {
    if (claim.status !== "pending") return;

    await tx.mutate.connectionClaims.update({
      id: claim.id,
      status: "dismissed",
    });
  },
});
